import w1 from '@assets/wp1.png';
import getRandomArrayElement from '@util/random-array-element';
import { useLayoutEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import styles from './auth.module.scss';
import { isTokenExpired } from '@util/jwt/token';
import { getTokens } from '@store';

export default function AuthLayout() {
  const [background, setBackground] = useState<string>('');
  const { token } = getTokens();

  useLayoutEffect(() => {
    setBackground(getRandomArrayElement([w1]));
  }, []);

  if (token && !isTokenExpired(token)) {
    return <Navigate to='/' />;
  }

  return (
    <main className={styles.container}>
      <img src={background} className={styles.image} />
      <Outlet />
    </main>
  );
}
